import { get } from 'lodash';

const PRODUCTION_RATING_EMAILS = [
  // production
  "mihaelasimionas+eo6prod@gmail.com",
  // "3stepsoccer@threestep.com",

  // staging
  "eotest@go4.io",
  "ryan.macknight+eo@go4.io",
  "ryan.macknight@go4.io",
  "mihaelasimionas+eo2@gmail.com",
  "mihaelasimionas+eo@gmail.com",
];

export const features = {
  RATING: 'rating',
};

const FEATURE_FLAGS = [
  {
    featureFlag: features.RATING,
    isEnabled: function (user, env) {

      const emails = get(this, `${env}Emails`, []);
      return emails.includes(user.email)
    },
    developmentEmails: [
      "eotest@go4.io",
    ],
    productionEmails: PRODUCTION_RATING_EMAILS,
  },
];

export const isEnabledFeature = (feature, user) => {
  const env = process.env.NODE_ENV;
  const flag = FEATURE_FLAGS.find(flag => flag.featureFlag === feature);

  if (!flag || !user) return false;

  return flag.isEnabled(user, env);
};

export default isEnabledFeature;
